import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import {useTranslation} from '../../hooks/useTranslation';

const DiagnosticsDashboard = () => {
    const {translation} = useTranslation();

    return (
        <div className="page-content">
            <h1>Dashboard</h1>
            <p>Bienvenue sur le tableau de bord.</p>

            <QuadralButton>Button test</QuadralButton>

            <h1>Test traduction : {translation('building')}</h1>
        </div>
    );
};

export default DiagnosticsDashboard;